import Text from "../../../../../styleguide/Text";
import ActionMenu from "../../../../../components/actionMenu/ActionMenu";
import useRoutesHelper from "../../../../../hooks/useRoutesHelper";
import usePermissions from "../../../../../router/usePermissions";
import userRoles from "../../../../../constants/userRoles";

function TableCustomHeader() {
  const { routeParams } = useRoutesHelper();
  const { nrauto } = routeParams as { nrauto: string };
  const { denumireEchipament } = routeParams as { denumireEchipament: string };
  const { isAuthorized } = usePermissions();

  const CAR_FEATURE_DOCUMENT_CREATE_PERMISSION = isAuthorized(
    userRoles.CAR_FEATURE_DOCUMENT_CREATE,
  );

  return (
    <div className="flex items-center justify-between gap-4">
      <Text
        variant="h3"
        component="h3"
        className="mb-4 font-semibold text-slate-900"
        gutterBottom>
        Documente echipament pentru auto {nrauto || ""} care asigura
        conformitatea transportului - {denumireEchipament}
      </Text>
      <ActionMenu
        items={[
          {
            id: "create-equipment-document",
            label: "Introducere document",
            icon: "ADD",
            tooltip:
              "Deschide formularul pentru un document nou al echipamentului.",
            hidden: !CAR_FEATURE_DOCUMENT_CREATE_PERMISSION,
            navigate: `create?nrauto=${nrauto}&denumireEchipament=${denumireEchipament}`,
          },
        ]}
        minItemsForMenu={2}
        title={denumireEchipament}
        ariaLabel={`Actiuni pentru documentele echipamentului ${denumireEchipament}`}
      />
    </div>
  );
}

export default TableCustomHeader;
